const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: { $ne: ['object.asset-class.options.healthcare-medical', 'object.asset-class.options.hotel'] } }]
}

export default conditions
